export const view = {
    methods:{
        submit: function(e){
            e.preventDefault();

            var parameters = this.getFormModel('recover');
            parameters.FranchiseID = localStorage.franchiseID;
            this.$ooApi.orders.accounts.recover.v1(parameters).then(function(response){
                if(response.success)
                    console.log(response.data);
                else
                    console.log(response.message);
            })
            // check .catch
        }
    }
}